module.exports = __webpack_public_path__ + "d2ebfb8712f5375ce406ca95b1255518.svg";